import Box from '@mui/material/Box';
import React, { useCallback } from 'react';
import {dateObjectToStringIsrael} from "../../../../../fromKotlin/nkutils";

interface ICustomerListSingleRow {
    data: any[];
    onDebtClick?: (row: any) => void;
}

const KartesetSingleRow: React.FC<ICustomerListSingleRow> = ({ data, onDebtClick }) => {
    const totalMdateCarteset = data.reduce((sum, item) => sum + (parseFloat(item.mdate_carteset) || 0), 0);
    const totalValueLeft = data.reduce((sum, item) => sum + (parseFloat(item.value_left) || 0), 0);

    // Calculate totals for חובה, זכות, יתרה
    const totalHova = data.reduce((sum, item) => sum + (parseFloat(item.value_tn) || 0), 0);
    const totalZchut = data.reduce((sum, item) => sum + (parseFloat(item.value_pay) || 0), 0);
    const totalYitrah = data[0]?.debt??''

    // Handler for debt click
    const handleDebtClick = useCallback((item) => {
        if (onDebtClick) onDebtClick(item);
    }, [onDebtClick]);
    console.log(data)
    return (
        <>
            {/* Header Row */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: 'black',
                    padding: '8px 12px',
                    maxWidth: '100vw',
                    background: '#f5f5f5',
                }}
            >
                <span>סוג מסמך / מספר</span>
                <span>חובה</span>
                <span>זכות</span>
                <span>יתרה</span>
            </Box>

            {/* Total Row */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: 'black',
                    padding: '8px 12px',
                    maxWidth: '100vw',
                    borderBottom: '1px solid black',
                    background: '#fafafa',
                }}
            >
                <span>סה"כ</span>
                <span>{totalHova.toLocaleString()}</span>
                <span>{totalZchut.toLocaleString()}</span>
                <span>{totalYitrah.toLocaleString()}</span>
            </Box>

            {/* Data Rows */}
            {data.map((item) => (
                <Box
                    key={item.id}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '2fr 1fr 1fr 1fr',
                        alignItems: 'center',
                        borderBottom: '1px solid #eee',
                        overflow: 'hidden',
                        width: '100%',
                        minHeight: 'fit-content',
                        fontSize: '13px',
                        padding: '8px 12px',
                        '@media (max-width: 600px)': {
                            fontSize: '12px',
                            padding: '6px 4px',
                        },
                    }}
                >
                    {/* סוג מסמך ומתחת מספרו */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span style={{ fontWeight: 500 }}>{item.name}</span>
                        <span style={{ fontSize: '11px', color: 'grey' }}>{item.id}</span>
                        <span style={{ fontSize: '11px', color: 'grey' }}>{(dateObjectToStringIsrael(item?.date))}</span>

                    </Box>
                    {/* חובה */}
                    <span style={{ cursor: onDebtClick ? 'pointer' : 'default', color: onDebtClick ? '#1976d2' : undefined }} onClick={() => handleDebtClick(item)}>
                        {item.value_tn?.toLocaleString() ?? ''}
                    </span>
                    {/* זכות */}
                    <span>{item.value_pay?.toLocaleString() ?? ''}</span>
                    {/* יתרה */}
                    <span style={{ fontWeight: item.debt === 0 ? 'bold' : undefined, color: item.debt === 0 ? 'green' : undefined }}>
                        {item.debt?.toLocaleString() ?? ''}
                    </span>
                </Box>
            ))}
        </>
    );
};

export default KartesetSingleRow;
